'use strict';

const SELECTOR = '.donation-panel';

export function init() {
    document.querySelectorAll(SELECTOR).forEach(element => {
        element.querySelector('#other').addEventListener('click', () => {
            element.querySelector('.donation-panel__specific-amount').classList.add('hidden');
            element.querySelector('.donation-panel__other-amount').classList.remove('hidden');

            element.querySelector('#custom_amount').tabIndex = 0;
            element.querySelector('#custom_amount').focus();

            element.querySelectorAll('[type="radio"]').forEach(radio => {
                radio.required = false;
            });

            element.querySelector('[type="number"]').required = true;
        });

        element.addEventListener('submit', event => {
            event.preventDefault();

            let amount = event.target.amount.value;
            const ct = event.target.ct.value;

            if (amount === '') {
                amount = parseInt(event.target.custom_amount.value, 10);
            }

            if (!amount) {
                return alert('Please select/specify a donation amount');
            }

            const url = new URL(event.target.action);
            url.searchParams.set('amount', amount);
            url.searchParams.set('ct', ct);
            window.location.href = url.toString();
        });
    });
}
